



















































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CostSummary extends Vue {
    @Prop({ required: true })
    private quotation!: any;

    private get q(): any {
        return this.quotation || {};
    }

    private get payments(): any[] {
        return this.q.payments || [];
    }

    private get totalTaxAndFeeCost(): number {
        if (this.q.total_tax_and_fee_cost !== undefined && this.q.total_tax_and_fee_cost !== null) {
            return Number(this.q.total_tax_and_fee_cost);
        }
        return Number(this.q.total_cost || 0);
    }

    private get tongHang(): number {
        if (this.q.tong_hang !== undefined && this.q.tong_hang !== null && Number(this.q.tong_hang) > 0) {
            return Number(this.q.tong_hang);
        }
        const items = this.q.items || [];
        const sum = items.reduce(
            (s: number, item: any) =>
                s + (Number(item.kt_chot_don_gia || item.don_gia_hoa_don_kh || 0) * Number(item.so_luong || 0)),
            0
        );
        return sum > 0 ? sum : Number(this.q.total_goods || this.q.total_goods_amount || 0);
    }

    private get thueVatXuatHoaDon(): number {
        if (this.q.thue_vat_xuat_hoa_don !== undefined && this.q.thue_vat_xuat_hoa_don !== null) {
            return Number(this.q.thue_vat_xuat_hoa_don);
        }
        const items = this.q.items || [];
        return items.reduce(
            (s: number, item: any) => s + Number(item.thue_vat_xuat_hoa_don || 0),
            0
        );
    }

    private get logisticsVatFeeAmount(): number {
        return Number(this.q.logistics_vat_fee_amount || 0);
    }

    private get companyCashflowAmount(): number {
        if (this.q.company_cashflow_amount !== undefined && this.q.company_cashflow_amount !== null) {
            return Number(this.q.company_cashflow_amount);
        }
        return Math.round(this.tongHang + this.thueVatXuatHoaDon + this.logisticsVatFeeAmount);
    }

    private get daThanhToanCompanyAmount(): number {
        if (this.q.da_thanh_toan_company !== undefined && this.q.da_thanh_toan_company !== null) {
            return Number(this.q.da_thanh_toan_company);
        }
        return this.payments
            .filter((p: any) => p.status === 'da_thanh_toan' && p.payment_type !== 'hoan_ung' && p.bank_account_type !== 'personal')
            .reduce((s: number, p: any) => s + Math.round(Number(p.amount || 0)), 0);
    }

    private get companyCashflowRemaining(): number {
        if (this.q.company_cashflow_remaining !== undefined && this.q.company_cashflow_remaining !== null) {
            return Number(this.q.company_cashflow_remaining);
        }
        return this.companyCashflowAmount - this.daThanhToanCompanyAmount;
    }

    private get netPersonalFlow(): number {
        if (this.q.net_personal_flow !== undefined && this.q.net_personal_flow !== null) {
            return Number(this.q.net_personal_flow);
        }
        return Math.round(this.totalTaxAndFeeCost - this.companyCashflowAmount);
    }

    private get daThanhToanPersonalAmount(): number {
        if (this.q.da_thanh_toan_personal !== undefined && this.q.da_thanh_toan_personal !== null) {
            return Number(this.q.da_thanh_toan_personal);
        }
        return this.payments
            .filter((p: any) => p.status === 'da_thanh_toan' && p.payment_type !== 'hoan_ung' && p.bank_account_type === 'personal')
            .reduce((s: number, p: any) => s + Math.round(Number(p.amount || 0)), 0);
    }

    private get conLaiPersonalPay(): number {
        if (this.q.con_lai_personal_pay !== undefined && this.q.con_lai_personal_pay !== null) {
            return Number(this.q.con_lai_personal_pay);
        }
        return Math.round(this.netPersonalFlow - this.daThanhToanPersonalAmount);
    }

    private get tongHoanVi(): number {
        if (this.q.tong_hoan_vi !== undefined && this.q.tong_hoan_vi !== null) {
            return Number(this.q.tong_hoan_vi);
        }
        return this.payments
            .filter((p: any) => p.status === 'da_thanh_toan' && p.payment_type === 'hoan_ung' && !p.is_compensation)
            .reduce((s: number, p: any) => s + Math.round(Number(p.amount || 0)), 0);
    }

    private get conLaiHoanVi(): number {
        if (this.q.con_lai_hoan_vi !== undefined && this.q.con_lai_hoan_vi !== null) {
            return Number(this.q.con_lai_hoan_vi);
        }
        return Math.round(this.conLaiPersonalPay + this.tongHoanVi);
    }

    private formatCurrency(val: number): string {
        const num = Number(val) || 0;
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'VND'
        }).format(num);
    }
}
